// extracted by mini-css-extract-plugin
export default {"img":"customer_photo_img__8-ULW","nameImg":"customer_photo_nameImg__S-0cd"};